export const PageLayout = ({ children, className }: { children: React.ReactNode; className?: string }) => {
    return (
        <div className={'h-screen'}>
            <div className={`${className}`}>{children}</div>
        </div>
    );
};
